module.exports = __webpack_public_path__ + "media/customer-support.dc0548ddf278e6b1cc8726d69bc3b5cb.svg";